import { render, staticRenderFns } from "./StcvL_List.vue?vue&type=template&id=5204e7e2"
import script from "./StcvL_List.vue?vue&type=script&lang=js"
export * from "./StcvL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports